import { useQuery } from '@tanstack/react-query';

import { economicIndices } from '@/shared/api/resources';

/**
 * Auxiliares das telas do endosso de aniversario e da renovacao (P-PAR-3) que nao sao
 * componentes: os prazos em dias, a taxa do aniversario e o catalogo de indices.
 */

/** Opcoes da taxa usada no endosso de aniversario (PRC-009 PENDENTE). */
export const taxasDoAniversario = [
  { value: 'taxa_da_apolice', label: 'Taxa da apolice' },
];

/**
 * Le um prazo em dias digitado. Vazio e "nao informado". O numero vai como foi
 * digitado: o com casa decimal e recusado pelo servidor, e nunca arredondado aqui.
 */
export function diasDoCampo(valor: string): number | null {
  const limpo = valor.trim();
  if (limpo === '') return null;
  const numero = Number(limpo);
  return Number.isFinite(numero) ? numero : null;
}

/** Escreve um prazo em dias, ou o traco quando nao foi informado. */
export function textoDosDias(dias: number | null | undefined): string {
  if (dias === null || dias === undefined) return '-';
  return dias === 1 ? '1 dia' : `${dias} dias`;
}

/** Os indices do catalogo, para o "Tipo de Indice". */
export function useIndices() {
  return useQuery({
    queryKey: ['economic-indices'],
    queryFn: ({ signal }) => economicIndices.list(signal),
    staleTime: 10 * 60_000,
  });
}

/** Nome do indice pelo codigo. */
export function nomeDoIndice(
  indices: { code: string; name: string }[] | undefined,
  codigo: string | null,
): string {
  if (!codigo) return '-';
  return indices?.find((indice) => indice.code === codigo)?.name ?? codigo;
}
